<template lang="html">
  <div class="batch-insert">
    <div class="content-i">
      <div class="content-box">
        <div class="element-wrapper">
          <h6 class="element-header">{{ t('titleBatchInsert','titleBatchInsert') }}</h6>

          <div class="element-box">
            <div class="element-info">
              <div class="row">
                <div class="col-12 col-sm-6 col-md-8">
                  <div class="element-info-with-icon">
                    <div class="element-info-icon">
                      <span class="os-icon os-icon-search2"></span>
                    </div>
                    <div class="element-info-text">
                      <h5 class="element-inner-header">{{ t('titleSearchDocs','titleSearchDocs') }}</h5>
                      <div class="element-inner-desc">{{ t('documentsSearchFormDesc','documentsSearchFormDesc') }}</div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-sm-3 col-md-4">
                  <i id="docuToggle" v-b-toggle.search class="os-icon os-icon-arrow-up float-right text-netsend-blue showhand"></i>
                </div>
              </div>
            </div>

            <b-collapse id="search" v-model="visibleSearchBox" >
              <form v-on:submit.prevent="searchDocuments">
                <div class="col-lg-12 row">
                  <div class="col-lg-2">
                      <template v-if="clientName != 'jfox'">
                        <div class="col-lg-12">
                          <div class="form-group">
                            <label for="customer-name" class="d-block text-center">{{t('searchLabelCustomerNameContains','searchLabelCustomerNameContains') }}</label>
                            <input id="customer-name" v-model="searchDocs.customer_name" class="form-control text-center" :placeholder="t('searchLabelCustomerName','searchLabelCustomerName')" type="text">
                          </div>
                        </div>
                      </template>
                      <div class="col-lg-12">
                        <template v-if="clientName == 'tota'">
                          <div class="form-group">
                            <label for="doc-ref-begins" class="d-block text-center">{{t('searchLabelDocumentRefBegins','searchLabelDocumentRefBegins') }}</label>
                            <input id="doc-ref-begins" v-model="searchDocs.doc_ref_begins" class="form-control text-center" :placeholder="t('searchLabelDocumentRefBegins','searchLabelDocumentRefBegins')" type="text">
                          </div>
                        </template>
                        <template v-else>
                          <div class="form-group">
                            <label for="doc-ref-contains" class="d-block text-center">{{t('searchLabelDocumentRefContains','searchLabelDocumentRefContains') }}</label>
                            <input id="doc-ref-contains" v-model="searchDocs.doc_ref_contains" class="form-control text-center" :placeholder="t('searchLabelDocumentRefContains','searchLabelDocumentRefContains')" type="text">
                          </div>
                        </template>
                      </div>
                    </div>
                    <div class="col-lg-2">
                      <template v-if="(Number(userLevel) > 0.50)">
                        <div class="col-lg-12">
                          <div class="form-group">
                            <label for="document-pages" class="d-block text-center">{{t('searchLabelDocNumOfPages','searchLabelDocNumOfPages') }}</label>
                            <input id="document-pages" v-model="searchDocs.doc_pages" class="form-control text-center" :placeholder="t('searchLabelDocNumOfPages','searchLabelDocNumOfPages')" type="text">
                          </div>
                        </div>
                      </template>
                      <template v-if="(Number(userLevel) == 3.00)">
                        <div class="col-lg-12">
                          <div class="form-group">
                            <label for="document-id" class="d-block text-center">{{t('searchLabelDocId','searchLabelDocId') }}</label>
                            <input id="document-id" v-model="searchDocs.doc_id" class="form-control text-center" :placeholder="t('searchLabelDocId','searchLabelDocId')" type="text">
                          </div>
                        </div>
                      </template>
                    </div>
                    <div class="col-lg-2">
                      <div v-if="(clientName == 'tota') && (userLevel >= 0.00)" class="col-lg-12">
                        <div class="form-group">
                          <label for="customer-reference" class="d-block text-center">{{t('searchLabelCustomerRefIs','searchLabelCustomerRefIs') }}</label>
                          <input id="customer-reference" v-model="searchDocs.customer_reference" class="form-control text-center" :placeholder="t('searchLabelCustomerRefIs','searchLabelCustomerRefIs')" type="text">
                        </div>
                      </div>
                      <div v-else-if="(clientName == 'brew') || (clientName == 'brewtest')" class="col-lg-12">
                        <div class="form-group">
                          <label for="customer-reference" class="d-block text-center">{{t('searchLabelCustomerRefIs','searchLabelCustomerRefIs') }}</label>
                          <input id="customer-reference" v-model="searchDocs.customer_reference" class="form-control text-center" :placeholder="t('searchLabelCustomerRefIs','searchLabelCustomerRefIs')" type="text">
                        </div>
                        <div class="form-group">
                          <label for="customer-ref" class="d-block text-center">{{t('searchLabelCustomerRefContains','searchLabelCustomerRefContains') }}</label>
                          <input id="customer-ref" v-model="searchDocs.customer_ref" class="form-control text-center" :placeholder="t('searchLabelCustomerRefContains','searchLabelCustomerRefContains')" type="text">
                        </div>
                      </div>
                      <div v-else class="col-lg-12">
                        <template v-if="exactCustomerRefReq">
                          <div class="form-group">
                            <label for="customer-reference" class="d-block text-center">{{t('searchLabelCustomerRefIs','searchLabelCustomerRefIs') }}</label>
                            <input id="customer-reference" v-model="searchDocs.customer_reference" class="form-control text-center" :placeholder="t('searchLabelCustomerRefIs','searchLabelCustomerRefIs')" type="text">
                          </div>
                        </template>
                        <template v-else>
                          <div class="form-group">
                            <label for="customer-ref" class="d-block text-center">{{t('searchLabelCustomerRefContains','searchLabelCustomerRefContains') }}</label>
                            <input id="customer-ref" v-model="searchDocs.customer_ref" class="form-control text-center" :placeholder="t('searchLabelCustomerRefContains','searchLabelCustomerRefContains')" type="text">
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-12 row justify-content-between pt-3">
                    <div class="col-lg-2">
                      <b-input-group class="col-lg-12">
                        <b-input-group-prepend>
                          <label class="input-group-text">{{ t('paginationPerPage','paginationPerPage') }}</label>
                        </b-input-group-prepend>
                        <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                      </b-input-group>
                    </div>
                    <div class="col-lg-4 align-self-center mr-2">
                      <button v-if="!isLoading" class="btn btn-primary float-right ml-2" type="submit">{{ t('searchButtonText','searchButtonText') }}</button>
                      <b-button v-if="isLoading" class="float-right ml-2" variant="primary" disabled>
                        <b-spinner small type="grow"></b-spinner>
                         {{ t('searchButtonText','searchButtonText') }}
                      </b-button>
                    </div>
                  </div>
              </form>
            </b-collapse>
            <div v-if="displaySettings.showLogoFiltering && businessUnitInfo" id="business-unit-logos" class="d-flex mt-4">
              <div class="col-lg-12">
                <a v-for="businessUnit in businessUnitInfo" :value="businessUnit.id" :key="businessUnit.id" class="d-inline-block showhand logo-filter">
                  <div v-if="logoFilterStatus(businessUnit.id) === 'turned-off'" @click="toggleBusinessUnitFilter('on', businessUnit.id)" class="logo-filter-block mr-2">
                    <img :src="businessUnit.logoUrl" :alt="businessUnit.name + ' logo'" class="logo-filter logo-filter-off" >
                    <fontAwesomeIcon  :icon="['fas', 'circle']" class="text-white image-select-icon-top-right" size="1x"/>
                  </div>
                  <div v-else class="logo-filter-block logo-filter-block-selected mr-2" @click="toggleBusinessUnitFilter('off', businessUnit.id)">
                    <img :src="businessUnit.logoUrl" :alt="businessUnit.name + ' logo'" class="logo-filter " >
                    <fontAwesomeIcon  :icon="['fas', 'check-circle']" class="text-primary image-select-icon-top-right" size="1x"/>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div  v-if="searched" class="element-content">
            <div  v-if="!isLoading && documents.length" class="row">
              <ResponseInfo v-if="getResponseInfo.responseName == 'batchInsertView'" />
              <div class="col-sm-12 col-md-12 col-lg-12">
                <div v-if="!isBusyTables" class="element-box col-12">
                  <b-form inline id="batchInsertFileUpload" @change="clearErrors()" v-on:submit.prevent="insertBatch">
                    <div class="col-sm-12 col-md-3">
                      <!--<span v-if="insertFile" class="mt-1">Selected file: {{ insertFile ? insertFile.name : '' }}</span>-->
                      <b-form-file
                        v-model="insertFile"
                        placeholder="Choose a file or drop it here..."
                        drop-placeholder="Drop file here..."
                        class="text-left"
                      ></b-form-file>
                    </div>
                    <div class="col-sm-12 col-md-9">
                      <b-button v-if="!multiInsert" type="submit" name="selected" class="mx-1" variant="primary" :disabled="allInsert" >{{ t('insertSelectedButtonText','insertSelectedButtonText') }}</b-button>
                      <b-button v-if="multiInsert" type="submit" name="selected" class="mx-1" variant="primary" disabled>
                        <b-spinner small type="grow"></b-spinner>
                        {{ t('insertSelectedButtonText','insertSelectedButtonText') }}
                      </b-button>

                      <b-button v-if="!allInsert" type="submit" name="all" class="mx-1" variant="primary" :disabled="multiInsert" >{{ t('insertAllButtonText','insertAllButtonText') }}</b-button>
                      <b-button v-if="allInsert" type="submit" name="all" class="mx-1" variant="primary" disabled>
                        <b-spinner small type="grow"></b-spinner>
                        {{ t('insertAllButtonText','insertAllButtonText') }}
                      </b-button>
                    </div>
                  </b-form>
                </div>
                
                <div class="element-box mt-2">
                  <vcl-table v-if="isBusyTables" :rows="2" :columns="2"></vcl-table>
                  <div v-if="!isBusyTables">
                    <div v-if="documents.length" class="controls-below-table pt-4 row">
                        <div class="table-records-info col-lg-6 col-sm-12" v-if="documents.length">
                          <p v-if="filter != null && filter.length" class="font-weight-bold mb-0">{{filteredRows}}</p>
                          <p v-else class="mb-0">
                            <template v-if="pagination.total == 1">
                            {{pagination.total}} {{ t('documentFoundLabel','documentFoundLabel') }}
                            </template>
                            <template v-else>
                            {{pagination.total}} {{ t('documentsFoundLabel','documentsFoundLabel') }}
                            </template>
                          </p>
                        </div>
                        <div class="col-lg-4 col-sm-12">
                          <b-pagination v-if="documents.length" ref="paginationTop" class="float-right mb-0" @change="paginate" v-model="pagination.current_page" :total-rows="pagination.total" :per-page="pagination.per_page" first-number last-number aria-controls="batches-table">
                          </b-pagination>
                        </div>
                        <div class="col-lg-2 col-sm-12 text-right">
                          <b-input-group class="col-lg-12">
                            <b-input-group-prepend>
                              <label class="input-group-text">{{ t('paginationPerPage','paginationPerPage') }}</label>
                            </b-input-group-prepend>
                            <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                          </b-input-group>
                        </div>
                    </div>

                    <b-table id="batch-insert-table" striped hover bordered responsive class="mt-3" :busy.sync="isBusyTables" :items="documents" :fields="clientSpecificFields" no-sort-reset @sort-changed="sortingChanged" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                    :total-rows="pagination.total" per-page="0" :currentPage="pagination.current_page" :filter="filter" @filtered="onFiltered" :show-empty="rowEmpty" foot-clone :tfoot-class="'footer-summary'" :thead-class="'brand-color'">
                      <template v-slot:head(checkbox)="data">
                        <template v-if="!allDocsToggle">
                          <fontAwesomeIcon @click="[checkAllDocs(), localToggle(true)]" :icon="['far', 'square']" class="showhand" size="2x"/>
                        </template>
                        <template v-if="allDocsToggle">
                          <fontAwesomeIcon @click="[unCheckAllDocs(), localToggle(false)]" :icon="['far', 'check-square']" class="showhand" size="2x"/>
                        </template>
                      </template>
                      <template v-slot:head(customer_ref)="data">
                        <span> {{ t(data.label, data.label) }}</span>
                      </template>
                      <template v-slot:head(customer_name)="data">
                        <span> {{ t(data.label, data.label) }}</span>
                      </template>
                      <template v-slot:head(type_name)="data">
                        <span >{{ t(data.label, data.label) }}</span>
                      </template>
                      <template v-slot:head(document)="data">
                        <span >{{ t(data.label, data.label) }}</span>
                      </template>
                      <template v-slot:head(pages)="data">
                        <span >{{ t(data.label, data.label) }}</span>
                      </template>
                      <template v-slot:head(value)="data">
                        <span >{{ t(data.label, data.label) }}</span>
                      </template>
                      <template v-slot:head(vat_value)="data">
                        <span >{{ t(data.label, data.label) }}</span>
                      </template>
                      <template v-slot:head(date)="data">
                        <span >{{ t(data.label, data.label) }}</span>
                      </template>
                      <template v-slot:head(pdf_insert_name)="data">
                        <span >{{ t(data.label, data.label) }}</span>
                      </template>
                      <template class="busy-row" v-slot:table-busy>
                        <vcl-table v-if="isLoading" :rows="pagination.per_page" :columns="5"></vcl-table>
                      </template>
                      <template v-slot:empty="scope">
                        <div class="text-center"> {{ t('noEntriesFound','noEntriesFound') }} </div>
                      </template>
                      <template v-slot:cell(checkbox)="data">
                        <b-form-checkbox :value="data.item.id" :unchecked-value="undefined" v-model="docsChecked" @change="checkDoc($event, data.item.id)"></b-form-checkbox>
                      </template>
                      <template v-slot:cell(customer_ref)="data">
                        <template v-if="(Number(userLevel) > 1.60)" >
                          <router-link class="hide-color" :to="{ path: `/customers_accounts/manage_customers?customerReference=` + `${data.item.customer_ref}`}" :title="t('tooltipViewCustomerDetails', 'tooltipViewCustomerDetails')">
                            {{ (data.item.customer_ref) ? data.item.customer_ref : t('labelNotYetAssigned', 'labelNotYetAssigned') }}
                          </router-link>
                        </template>
                        <template v-else>
                          <span class="hide-color" :id="'cust_reference_' + data.item.id"> {{ (data.item.customer_ref) ? data.item.customer_ref : t('labelNotYetAssigned', 'labelNotYetAssigned') }} </span>
                        </template>
                      </template>
                      <template v-slot:cell(customer_name)="data">
                        <span class="hide-color">{{ data.item.customer_name }}</span>
                      </template>
                      <template v-slot:cell(type_name)="data">
                        <span class="hide-color">
                          {{ data.item.type_name }}
                        </span>
                      </template>
                      <template v-slot:cell(document)="data">
                        <router-link class="hide-color" :to="{ name: 'view_document', params: { id: data.item.id, type: 'online' }}" v-on:click.native="setasRead(data.item.id)" target="_blank">
                          {{ data.item.reference }}
                        </router-link>
                        <template v-if="((Number(userLevel) > 1.60) && (data.item.batch_status != 'rejected')) || (Number(userLevel) > 2.50)">
                          <template v-if="data.item.email_cover == 1">
                            <router-link class="hide-color" :to="{ name: 'view_document', params: { id: data.item.id, type: 'email_cover' }}" target="_blank">
                              [e]
                            </router-link>
                          </template>
                          <template v-if="data.item.fax_cover == 1">
                            <router-link class="hide-color" :to="{ name: 'view_document', params: { id: data.item.id, type: 'fax_cover' }}" target="_blank">
              							  [f]
              							</router-link>
                          </template>
                          <template v-if="data.item.post_cover == 1">
                            <router-link class="hide-color" :to="{ name: 'view_document', params: { id: data.item.id, type: 'post_cover' }}" target="_blank">
              							  [p]
              							</router-link>
                          </template>
                        </template>
                        <template v-if="userLevel == 3.00">
                          <fontAwesomeIcon :icon="['fas', 'info-circle']" size="lg" :id="'info-' + data.item.id"
                          @click="modalCreator({id: 'infoModal', title: t('documentInfoModalHead','documentInfoModalHead'), level: 'main', open: 'open'}, data.item, $event.target)"
                          class="text-primary showhand align-middle ml-1" visibility="visible"/>
                        </template>
                      </template>
                      <template v-slot:cell(pages)="data">
                        <span v-if="Number(userLevel) > 1.00" class="hide-color">{{ data.item.num_of_pages }}</span>
                        <span v-else>{{t('unknown','unknown')}}</span>
                      </template>
                      <template v-slot:cell(value)="data">
                        <template v-if="data.item.total_value">
                          <template v-if="formatValues">
                            <span class="hide-color">{{ data.item.total_value | numberFormatWithComma(2) }}</span>
                          </template>
                          <template v-else>
                            <span class="hide-color">{{ data.item.total_value | numberFormat(2) }}</span>
                          </template>
                        </template>
                      </template>
                      <template v-slot:cell(vat_value)="data">
                        <template v-if="formatValues">
                          <span class="hide-color">{{ data.item.vat_value | numberFormatWithComma(2) }}</span>
                        </template>
                        <template v-else>
                          <span class="hide-color">{{ data.item.vat_value | numberFormat(2) }}</span>
                        </template>
                      </template>
                      <template v-slot:cell(date)="data">
                        <template v-if="(Number(userLevel) > 1.60) && (displaySettings.deliveryReports)">
                          <router-link class="hide-color" :to="{name:'delivery_reports', query: {page: 1, per_page: 20}, params: {docs: Array.of(data.item.id)}}" :title="t('viewDeliveryDetails', 'viewDeliveryDetails')">
                              {{ data.item.document_date | clientDateFormatter(datePickerFormat, false) }}
                          </router-link>
                        </template>
                        <template v-else>
                          <span class="hide-color">{{ data.item.document_date | clientDateFormatter(datePickerFormat, false) }}</span>
                        </template>
                      </template>
                      <template v-slot:cell(pdf_insert_name)="data">
                        <span>{{data.item.pdf_insert_name}}</span>
                      </template>
                      <template v-slot:foot(checkbox)="data">
                        <div></div>
                      </template>
                      <template v-slot:foot(customer_ref)="data">
                        <div></div>
                      </template>
                      <template v-slot:foot(customer_name)="data">
                        <div></div>
                      </template>
                      <template v-slot:foot(type_name)="data">
                        <div></div>
                      </template>
                      <template v-slot:foot(document)="data">
                        <div></div>
                      </template>
                      <template v-slot:foot(pages)="data">
                        <div></div>
                      </template>
                      <template v-slot:foot(value)="data">
                        <template v-if="(displaySettings.totalValueReq != 0.0) && (userLevel >= displaySettings.totalValueReq)">
                          <template v-if="calculations.totalValue">
                            <template v-if="formatValues">
                              <span class="hide-color">{{ calculations.totalValue | numberFormatWithComma(2) }}</span>
                            </template>
                            <template v-else>
                              <span class="hide-color">{{ calculations.totalValue | numberFormat(2) }}</span>
                            </template>
                          </template>
                          <template v-else>
                            <div></div>
                          </template>
                        </template>
                      </template>
                      <template v-slot:foot(vat_value)="data">
                        <template v-if="(displaySettings.vatValueReq != 0.0) && (userLevel >= displaySettings.vatValueReq)">
                          <template v-if="calculations.totalVatValue">
                            <template v-if="formatValues">
                              <span class="hide-color">{{ calculations.totalVatValue | numberFormatWithComma(2) }}</span>
                            </template>
                            <template v-else>
                              <span class="hide-color">{{ calculations.totalVatValue | numberFormat(2) }}</span>
                            </template>
                          </template>
                        </template>
                        <template v-else>
                          <div></div>
                        </template>
                      </template>
                      <template v-slot:foot(date)="data">
                        <div></div>
                      </template>
                      <template v-slot:foot(pdf_insert_name)="data">
                        <div></div>
                      </template>
                    </b-table>

                    <div v-if="documents.length" class="controls-below-table pt-4 row">
                        <div class="table-records-info col-lg-6 col-sm-12" v-if="documents.length">
                          <p v-if="filter != null && filter.length" class="font-weight-bold mb-0">{{filteredRows}}</p>
                          <p v-else class="mb-0">
                            <template v-if="pagination.total == 1">
                            {{pagination.total}} {{ t('documentFoundLabel','documentFoundLabel') }}
                            </template>
                            <template v-else>
                            {{pagination.total}} {{ t('documentsFoundLabel','documentsFoundLabel') }}
                            </template>
                          </p>
                        </div>
                        <div class="col-lg-4 col-sm-12">
                          <b-pagination v-if="documents.length" ref="paginationBottom" class="float-right mb-0" @change="paginate" v-model="pagination.current_page" :total-rows="pagination.total" :per-page="pagination.per_page" first-number last-number aria-controls="batches-table">
                          </b-pagination>
                        </div>
                        <div class="col-lg-2 col-sm-12 text-right">
                          <b-input-group class="col-lg-12">
                            <b-input-group-prepend>
                              <label class="input-group-text">{{ t('paginationPerPage','paginationPerPage') }}</label>
                            </b-input-group-prepend>
                            <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                          </b-input-group>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="!documents.length" id="no-docs" class="element-box">
              <p class="text-center">{{ t('noDocsFound', 'NoDocsFound') }}</p>
            </div>

            <ModalInfoDoc :modal="(getModalLevel('info') == 'main')? this.modal : this.subModal"/>
            <div v-if="this.modal['modalData'].open" class="modal-backdrop show"></div>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import moment from 'moment'
    import ResponseInfo from '@/components/ResponseInfo.vue'
    import ModalInfoDoc from '@/components/Documents_Search/ModalInfoDoc.vue'
    import { clientShortName } from '@/helpers/clientShortName.js'
    import { VclTable } from 'vue-content-loading'
    import 'bootstrap-vue/dist/bootstrap-vue.css'

    export default {
    name: 'batch_insert',
    provide() {
      return {
          resetModal: this.resetModal,
          modalCreator: this.modalCreator,
          changeModalLevel: this.changeModalLevel,
          getModalLevel: this.getModalLevel,
          subModal: this.subModal
      }
    },
    data() {
      return {
        searchDocs : {
          business_unit_filter: []
        },
        page: 1,
        perPage: 20,
        newPage: 1,
        newPerPage: 20,
        rowEmpty: false,
        filter: null,
        sortBy: null,
        sortDesc: false,
        allDocsToggle: false,
        docsChecked: [],
        visibleSearchBox: true,
        isLoading: false,
        isInserting: false,
        multiInsert: false,
        allInsert: false,
        isBusyTables: false,
        pageOptions: [10, 20, 50, 100],
        insertFile: [],
        searched: false,
        clientSpecificFields: null,
        //Data storage for the modal
        modal: {
          modalData: {},
          docuData: {},
          updateData: {}
        },
        subModal: {
          modalData: {},
          docuData: {},
          itemData: {},
          updateData: {}
        }
      }
    },
    computed: {
        ...mapGetters(['allTemplateDetails', 'getUserDetails', 'getResponseInfo']),
        //...mapGetters('batchInsertStore', ['getDisplaySettings']),
        displaySettings() {
          return this.$store.getters['batchInsertStore/getDisplaySettings']
        },
        formatValues() {
          return this.allTemplateDetails.format_values
        },
        documents() {
          return this.$store.getters['batchInsertStore/getDocuments']
        },
        calculations() {
          return this.$store.getters['batchInsertStore/getCalculations']
        },
        pagination() {
          return this.$store.getters['batchInsertStore/getPagination']
        },
        datePickerFormat() {
          if(this.$store.getters.allTemplateDetails && this.$store.getters.allTemplateDetails.datePickerFormat) {
            let dateformat = this.$store.getters.allTemplateDetails.datePickerFormat.replace(/-/g, '/')
            return dateformat
          } else {
            return "DD-MM-YYYY"
          }
        },
        clientName() {
          let clientName = clientShortName()
          return clientName
        },
        userLevel() {
          return this.$store.getters.getUserLevel
        },
        businessUnitInfo() {
          return this.$store.getters['documentsStore/getBusinessUnitLogoFilters']
        },
        batchId() {
          if (this.$route.query.batch){
            return this.$route.query.batch
          } else{
            return null
          }
        },
        exactCustomerRefReq() {
          // This is either a special request for Travelport Staff for an "exact" search or
      		// it's coming from the Manage Customers page
      		if ( (this.clientName == 'trav') && ( (this.userLevel == 0.5) || (this.userLevel == 1.00) ) ) {
      			return true
      		} else if (this.$route.query.exact_cust_ref && (this.$route.query.exact_cust_ref == 'Y')) {
            //if there is a key in the url for the exact customer ref
      			return true
      		} else if ((this.clientName == 'tota') && (this.userLevel >= 0.0)) {
            // TOTA admins *MUST* use exact customer refs
      			return true
      		} else {
      			return false
      		}
        },
        /* clientSpecificFields() {
          return this.$store.getters['batchInsertStore/getClientSpecificFields']
        }, */
        searchPerPage() {
          return this.perPage
        }

    },
    watch:{
      searchPerPage() {
        this.searchDocuments()
      }
    },
    methods: {
      //PAGINATION
      paginate(newPage) {
        let page = parseInt(newPage)
        if(this.page !== page) {
          this.page = page
          this.searchDocuments()
        }
      },
      //MODALS
      modalCreator(modalData, docuData, button) {
        if(modalData.level == 'main') {
          this.modal.modalData = modalData
          this.modal.docuData = { ...docuData }

          this.$root.$emit('bv::show::modal', this.modal.modalData.id, button)
        }
        if(modalData.level == 'sub') {
          this.subModal.modalData = modalData
          this.subModal.docuData = { ...docuData }

          this.$root.$emit('bv::show::modal', this.subModal.modalData.id, button)
        }

      },
      resetModal(level, button = '') {
        if(level == 'main') {

          Object.keys(this.modal['modalData']).forEach((key) => (key === 'id') ? this.modal['modalData'][key] : (this.modal['modalData'][key] = '' ))
          Object.keys(this.modal['docuData']).forEach((key) => (this.modal['docuData'][key] = '' ))
          Object.keys(this.modal['updateData']).forEach((key) => (this.modal['updateData'][key] = '' ))

          this.$store.dispatch('alertClearResponse')
        }
        if(level == 'sub') {
          Object.keys(this.subModal['modalData']).forEach((key) => (key === 'id') ? this.subModal['modalData'][key] : (this.subModal['modalData'][key] = '' ))
          Object.keys(this.subModal['docuData']).forEach((key) => (this.subModal['docuData'][key] = '' ))
          Object.keys(this.subModal['updateData']).forEach((key) => (this.subModal['updateData'][key] = '' ))

          this.$store.dispatch('alertClearResponse')
        }
      },
      getModalLevel(modal) {
        switch (modal) {
          case 'info':
            return this.modalLevelInfo
            break;
          default:
            break;
        }
      },
      changeModalLevel(modal, level) {
        switch (modal) {
          case 'info':
            this.modalLevelInfo = level
            break;
          default:
            break;
        }
      },
      setasRead(docId) {
        let docs = []
        docs.push(docId)
        this.$store.dispatch('documentToolsStore/handleDocumentTool', {action: 'markDocumentsRead', documents: docs})
      },
      //CHECKBOXES FOR DOCUMENTS
      checkAllDocs() {
        let docs = this.documents
        let allDocIds = []
        Object.keys(docs).forEach((key) => (allDocIds.push(docs[key].id)))
        this.docsChecked = allDocIds
      },
      unCheckAllDocs() {
        this.docsChecked = []
      },
      thisDocChecked(docId) {
        if(this.docsChecked.includes(docId)){
          return true
        } else {
          return false
        }
      },
      localToggle(bool) {
        this.allDocsToggle = bool
      },
      checkDoc(event, docId) {
          if(event) {
            this.docsChecked.push( docId )
            if(this.documents.length == this.docsChecked.length) {
              this.localToggle(true)
            }
          } else {

            let removeKey = null
            for (let index in this.docsChecked) {
              if(this.docsChecked[index] == docId) {
                  removeKey = index
              }
            }

            if(removeKey != null) {
              this.docsChecked.splice(removeKey, 1)
              this.localToggle(false)
            }
          }
      },
      //SORTING
      sortingChanged(ctx) {
        let sortField = ctx.sortBy
        let sortOrder = (ctx.sortDesc == true) ? 'ASC' : 'DESC'
        this.sortBy = sortField
        this.sortDesc = ctx.sortDesc
        this.changeSorting(sortField, sortOrder)
      },
      changeSorting(sortField, sortOrder) {
        this.$route.query.sort_field = sortField
        this.searchDocs.sort_field = sortField
        this.$route.query.sort_direction = sortOrder
        this.searchDocs.sort_direction = sortOrder
        this.searchDocuments()
      },
      onFiltered(filteredItems) {
        this.filteredRows = filteredItems.length
        this.currentPage = 1
      },
      //BUSINESS UNIT FILTER
      logoFilterStatus(unitId) {
        let businessUnitFilter = this.searchDocs.business_unit_filter
        if(businessUnitFilter == undefined) {
          return 'turned-off'
        }
        if(businessUnitFilter.includes(unitId)) {
            return 'turned-on'
        } else {
            return 'turned-off'
        }
      },
      toggleBusinessUnitFilter(option, unitId) {
        let businessUnitFilter = this.searchDocs.business_unit_filter
        if(businessUnitFilter == undefined) {
          this.searchDocs.business_unit_filter = []
        }
        if(option === 'on') {
          this.searchDocs.business_unit_filter.push(unitId)
        }
        if(option === 'off') {
          this.searchDocs.business_unit_filter.splice( this.searchDocs.business_unit_filter.indexOf(unitId), 1 );
        }
        this.searchDocuments()
      },
      clearErrors() {
        //clearing the error message when we change the input
        this.$store.commit('setValidationErrors', [])
      },
      insertBatch(event) {
        this.isInserting = true

        let insertType = event.submitter.name
        let formData = new FormData();
        formData.append('insertFile', this.insertFile)
        formData.append('insertType', insertType)
        if(insertType == 'selected') {
          this.multiInsert = true
          formData.append('documents', this.docsChecked)
        } else {
          this.allInsert = true
        }

        formData.append('batchId', this.batchId)

        this.$store.dispatch('batchInsertStore/batchInsert', formData)
        .then(() => {
          this.insertFile = []
          this.isInserting = false
          this.docsChecked = []
          this.searchDocuments()

          this.multiInsert = false
          this.allInsert = false
        })
      },
      searchDocuments() {
        this.isBusyTables = true
        this.isLoading = true

        if(this.searchDocs.customer_ref != undefined) {
          if((typeof this.searchDocs.customer_ref == "string") && this.searchDocs.customer_ref.includes(',')) {
            let refs = this.searchDocs.customer_ref.split(",")
            Object.keys(refs).forEach((key) => ( refs[key] = refs[key].trim() ))
            refs = refs.filter(function(value, index, arr){
              return value !== "";
            });
            this.searchDocs.customer_ref = refs
          }
        }

        if(!this.searched) {
          if(!(this.perPage == this.newPerPage)) {
            this.perPage = this.newPerPage
          }
          if(!(this.page == this.newPage)) {
            this.page = this.newPage
          }
        }

        Object.keys(this.searchDocs).forEach((key) => ((this.searchDocs[key] == '') || (this.searchDocs[key] == null)) && (this.searchDocs[key] = undefined))
        this.$router.push({ query: { ...this.$route.query, ...this.searchDocs, page: this.page, per_page: this.perPage} })

        this.$store.dispatch('batchInsertStore/getDocumentsForBatchInsert', {
          page: this.$route.query.page,
          per_page: this.$route.query.per_page,
          batch_id: this.$route.query.batch,
          sort_field: this.$route.query.sort_field,
          sort_direction: this.$route.query.sort_direction,
          docs: this.$route.query.docs,
          business_unit_filter: this.$route.query.business_unit_filter,
          //Determines if we must search by exact customer reference
          exact_cust_ref: this.$route.query.exact_cust_ref,
          //Search for customer reference "is"
          customer_reference: this.$route.query.customer_reference,
          //Search for customer reference "contains"
          customer_ref: this.$route.query.customer_ref,
          customer_name: this.$route.query.customer_name,
          doc_pages: this.$route.query.doc_pages,
          doc_ref_begins: this.$route.query.doc_ref_begins,
          doc_ref_contains: this.$route.query.doc_ref_contains,
          doc_id: this.$route.query.doc_id
        })
        .then(response => {
            this.searchDocs = { ...this.$route.query}
            //this.$store.dispatch('batchInsertStore/getClientSpecificFields', {view: 'batchInsert'})
            this.clientSpecificFields = response.columnHeaders 
            this.searched = true
            this.isBusyTables = false
            this.isLoading = false
        })
      }
    },
    created() {
      this.modalLevelInfo = 'main'
      //fetching the business unit logos for the searchbar if we have any
      this.$store.dispatch('batchInsertStore/getDisplaySettings').then(
        () => {
          if(this.displaySettings.showLogoFiltering) {
            //get business unit info
            this.$store.dispatch('documentsStore/getBusinessUnitLogoFilters')
          }
        }
      )

      if(this.$route.query.page) {
        this.newPage = this.$route.query.page
      }

      if(this.$route.query.per_page) {
        this.newPerPage = this.$route.query.per_page
      }

      this.searched = false
      if(this.$route.query.batch) {
        this.isLoading = true
        this.isBusyTables = true
        this.searchDocuments()
      }
    },
    filters: {
      numberFormat: function(number, digits) {
        return Number.parseFloat(number).toFixed(digits)
      },
      numberFormatWithComma: function(number, digits) {
        let numberString = Number.parseFloat(number).toFixed(digits)
        return numberString.replace('.', ',')
      },
      clientDateFormatter: function(date, datePickerFormat, withTime) {
        if(withTime) {
          return moment(date).format(datePickerFormat + ' h:mm:ss')
        } else {
          return moment(date).format(datePickerFormat)
        }
      }
    },
    components: {
      ResponseInfo,
      ModalInfoDoc,
      VclTable
    }
}
</script>

<style lang="css" scoped>
.showhand {
  cursor: pointer;
}

/*-----SEARCH BAR-----*/
.text-netsend-blue{
  color: #047bf8;
}
.docu-search-border{
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 10px;
  border-radius: 10px;
}
#docuToggle{
  font-size: 1.2rem;
  font-weight: bold;
  display:inline-block;
  -moz-transition: all .5s linear;
  -webkit-transition: all .5s linear;
  transition: all .5s linear;
}
#docuToggle.collapsed{
  -moz-transform:rotate(180deg);
  -webkit-transform:rotate(180deg);
  transform:rotate(180deg);
}

/*TABLE*/
.table-responsive  >>> .brand-color {
  background-color: #047bf8 !important;
  color: white !important;
}
.table-responsive  >>> .footer-summary {
  background-color: lightgrey !important;
}
.table-responsive >>> .row-hidden{
  font-style: italic;
}
.table-responsive >>> .row-hidden a{
  color: grey !important;
  /*text-decoration: underline;*/
}
.table-responsive >>> .row-hidden .hide-color{
  color: grey !important;
}
.table-responsive >>> .row-unread{
  font-weight: bold;
}

/*BUSINESS UNIT LOGO FILTERS*/
#business-unit-logos{
  height: 70px;
  overflow: auto;
  white-space: nowrap;
}
.logo-filter{
  height: 50px;
  border-radius: 5px;
}
.logo-filter-off{
  -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
  filter: grayscale(100%);
}
.logo-filter-block{
  box-shadow: 0px 2px 4px rgba(126, 142, 177, 0.12);
  border-radius: 5px;
}
.logo-filter-block-selected{
  border: 1px solid #047bf8;
}
.image-select-icon-top-right{
  vertical-align:top;
  padding: 1px;
}

</style>
